import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tracker-query-edit-main',
  template: require('./tracker.query.edit.main.component.html'),
})
export class TrackerQueryEditMainComponent implements OnInit {
  @Input() query: any;
  @Input() sortByField: any;
  @Input() isMine: boolean;
  @Input() isNew: boolean;

  showOwner: boolean = false;

  fieldSettingsSingle = {
    showUncheckAll: false,
    showcheckAll: false,
    selectionLimit: 1
  };

  ngOnInit() {
    this.showOwner = !this.isMine && !this.isNew;
  }

  toggleVisibility() {
    this.query.isShared = !this.query.isShared;
  }
}
